import React, { Component } from 'react'
import { connect } from 'react-redux';
import { setFilter } from '../../actions/filters'
import getParams from '../utilities/getParams'

// UI component for dropdown.
const StatusFilterDropdown = ({ value, handleChange }) => (
    <select value={value}
        className="form-control"
        onChange={handleChange}
    >
        <option value="0">Search status</option>
        <option value="100">Completed</option>
        <option value="1">Processing</option>
        <option value="-1">Failed</option>
    </select>
)

// Actual class
class StatusFilter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            input1: '0'
        }
        this.handleStatusFilterDropdown = this.handleStatusFilterDropdown.bind(this)
        this.clearFilter = this.clearFilter.bind(this)
        this.mainInput = HTMLSelectElement

    }

    clearFilter() {
        this.setState({
            input1: '0'
        })
    }

    handleStatusFilterDropdown(event) {
        // let newInput = Number(event.target.value)
        let newInput = event.target.value.toString()

        this.setState({
            input1: newInput
        })
    }

    componentDidUpdate() {
        this.bindToState()
    }

    componentDidMount() {
        const params = getParams(this.props.location && this.props.location.search ? this.props.location.search : "")
        const getStatus = params.status;

        const getProps = this.props
        const getPreviousValue = this.props.value1.toString()

        let validateStatus = "";

        if (getStatus == 'failed') {
            validateStatus = "-1";
        } else if (getStatus == 'completed') {
            validateStatus = "100";
        } else if (getStatus == 'processed') {
            validateStatus = "1";
        } else {
            validateStatus = "0";
        }

        //     let validateStatus = "";
        //     switch (param) {
        //         case "failed":
        //             validateStatus = "-1";
        //         case "completed":
        //             validateStatus = "100";
        //         case "processing":
        //             validateStatus = "1";
        //         default:
        //             validateStatus = "";
        //     }

        this.setState({
            input1: getStatus ? validateStatus : getPreviousValue
        })

    }

    bindToState() {
        let filter = {}
        filter[this.props.filterName] = {
            type: "enum",
            value1: this.state.input1.toString()
        }
        this.props.dispatch(setFilter(
            this.props.id,
            filter
        ))

    }


    render() {
        // let i1 = this.props.value1
        return (
            <div className="form-group">
                <StatusFilterDropdown
                    value={this.state.input1}
                    handleChange={this.handleStatusFilterDropdown}
                />
            </div>
        )
    }
}

export default connect(null, null, null, { withRef: true })(StatusFilter)


// WEBPACK FOOTER //
// ./src/components/filters/statusFilter.js